module.exports = {
      id: "tamilnadu-usage",
      viewBox: "0 0 857.199 1020.664",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#tamilnadu",
      toString: function () {
        return this.url;
      }
    }